import {DIGIT_STRING_VALIDATION_REGEX} from "../../constants/validationConstants";

export const onlyDigits = value => DIGIT_STRING_VALIDATION_REGEX.test(value) || value === null ? value : undefined;
